import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsDirectory, CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const TaskBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { open, close } = useCommands();
    const {
        selectedTaskCount = 0,
        taskBulkStatusOptions,
        taskBulkMemberOptions,
        taskBulkPriorityOptions,
        taskBulkTaskGroupOptions,
        taskBulkEntityOptions,
        onTaskBulkDelete,
    } = options;

    const heading = `${selectedTaskCount} ${pluralize("task", selectedTaskCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {taskBulkStatusOptions && (
                <CommandItem
                    keywords={["status", "set status"]}
                    onSelect={() =>
                        open(CommandsDirectory.TASK_BULK_STATUS, options)
                    }
                >
                    Set status
                </CommandItem>
            )}
            {taskBulkMemberOptions && (
                <CommandItem
                    keywords={["assign", "member", "assignee"]}
                    onSelect={() =>
                        open(CommandsDirectory.TASK_BULK_MEMBER, options)
                    }
                >
                    Assign member
                </CommandItem>
            )}
            {taskBulkPriorityOptions && (
                <CommandItem
                    keywords={[
                        "priority",
                        "set priority",
                        "urgent",
                        "high",
                        "low",
                    ]}
                    onSelect={() =>
                        open(CommandsDirectory.TASK_BULK_PRIORITY, options)
                    }
                >
                    Set priority
                </CommandItem>
            )}
            {taskBulkTaskGroupOptions && (
                <CommandItem
                    keywords={["task group", "group", "move to group"]}
                    onSelect={() =>
                        open(CommandsDirectory.TASK_BULK_TASK_GROUP, options)
                    }
                >
                    Set task group
                </CommandItem>
            )}
            {taskBulkEntityOptions && taskBulkEntityOptions.length > 0 && (
                <CommandItem
                    keywords={["entity", "entities", "set entity", "client"]}
                    onSelect={() =>
                        open(CommandsDirectory.TASK_BULK_ENTITY, options)
                    }
                >
                    Set entities
                </CommandItem>
            )}
            {onTaskBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove", "trash"]}
                    onSelect={() => {
                        close();
                        onTaskBulkDelete();
                    }}
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
